import makeStyles from '@mui/styles/makeStyles';

const useConfirmationDialogStyles = makeStyles(() => ({
    text: {
        fontSize: '0.9rem'
    }
}));

export default useConfirmationDialogStyles;
